import { useSEO } from '../../utils/seo';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

interface BlogPost {
  id: string;
  title: string;
  excerpt: string;
  date: string;
  author: string;
  category: string;
  image: string;
  slug: string;
  readTime: string;
}

const blogPosts: BlogPost[] = [
  {
    id: '1',
    title: 'Breaking Barriers: How Mentorship Transforms Latina Professionals',
    excerpt: 'Discover how mentorship programs are creating pathways for Latina women to break through glass ceilings and achieve leadership positions in their careers.',
    date: '2025-01-15',
    author: 'Maria Rodriguez',
    category: 'Mentorship',
    image: 'https://public.readdy.ai/ai/img_res/62b89caf4b6054736ef516f7fe0a0687.jpg',
    slug: 'breaking-barriers-mentorship-transforms-latina-professionals',
    readTime: '5 min read'
  },
  {
    id: '2',
    title: 'The Power of Community: Building Networks That Elevate',
    excerpt: 'Learn how building strong professional networks within the Latina community creates opportunities for growth, collaboration, and mutual success.',
    date: '2025-01-12',
    author: 'Carmen Silva',
    category: 'Community',
    image: 'https://readdy.ai/api/search-image?query=diverse%20group%20of%20latina%20professionals%20networking%20at%20community%20event%20with%20warm%20collaborative%20atmosphere%20and%20professional%20setting&width=800&height=500&seq=blog2&orientation=landscape',
    slug: 'power-of-community-building-networks',
    readTime: '4 min read'
  },
  {
    id: '3',
    title: 'From Student to Leader: Success Stories from MAS Academy',
    excerpt: 'Read inspiring stories from MAS Academy graduates who have transformed their careers through our workshops and mentorship programs.',
    date: '2025-01-10',
    author: 'Isabella Martinez',
    category: 'Success Stories',
    image: 'https://readdy.ai/api/search-image?query=successful%20latina%20professional%20woman%20presenting%20at%20workshop%20with%20confident%20posture%20in%20bright%20modern%20training%20room%20with%20engaged%20audience&width=800&height=500&seq=blog3&orientation=landscape',
    slug: 'student-to-leader-mas-academy-success-stories',
    readTime: '6 min read'
  },
  {
    id: '4',
    title: 'Navigating Career Transitions: A Guide for Latina Professionals',
    excerpt: 'Essential strategies and insights for successfully navigating career changes, from switching industries to climbing the corporate ladder.',
    date: '2025-01-08',
    author: 'Sofia Hernandez',
    category: 'Career Development',
    image: 'https://readdy.ai/api/search-image?query=latina%20professional%20woman%20planning%20career%20path%20with%20documents%20and%20laptop%20in%20bright%20modern%20office%20with%20motivational%20atmosphere&width=800&height=500&seq=blog4&orientation=landscape',
    slug: 'navigating-career-transitions-guide',
    readTime: '7 min read'
  },
  {
    id: '5',
    title: 'Leadership Skills Every Latina Professional Should Master',
    excerpt: 'Explore the essential leadership skills that will help you stand out and succeed in today\'s competitive workplace environment.',
    date: '2025-01-05',
    author: 'Gabriela Torres',
    category: 'Leadership',
    image: 'https://readdy.ai/api/search-image?query=confident%20latina%20business%20leader%20presenting%20to%20team%20in%20modern%20boardroom%20with%20professional%20atmosphere%20and%20natural%20lighting&width=800&height=500&seq=blog5&orientation=landscape',
    slug: 'leadership-skills-latina-professionals',
    readTime: '5 min read'
  },
  {
    id: '6',
    title: 'The Impact of Representation: Why Latina Mentors Matter',
    excerpt: 'Understanding the profound impact that having Latina mentors and role models has on career development and personal growth.',
    date: '2025-01-03',
    author: 'Ana Ramirez',
    category: 'Mentorship',
    image: 'https://readdy.ai/api/search-image?query=latina%20mentor%20and%20mentee%20having%20meaningful%20conversation%20in%20professional%20office%20setting%20with%20warm%20supportive%20atmosphere&width=800&height=500&seq=blog6&orientation=landscape',
    readTime: '4 min read'
  },
  {
    id: '7',
    title: 'Overcoming Imposter Syndrome in the Workplace',
    excerpt: 'Practical strategies to recognize and overcome imposter syndrome, building confidence in your professional abilities and achievements.',
    date: '2024-12-28',
    author: 'Lucia Morales',
    category: 'Personal Growth',
    image: 'https://readdy.ai/api/search-image?query=empowered%20latina%20professional%20woman%20standing%20confidently%20in%20modern%20office%20with%20positive%20energy%20and%20professional%20attire&width=800&height=500&seq=blog7&orientation=landscape',
    slug: 'overcoming-imposter-syndrome-workplace',
    readTime: '6 min read'
  },
  {
    id: '8',
    title: 'Building Your Personal Brand as a Latina Professional',
    excerpt: 'Learn how to create and maintain a strong personal brand that showcases your unique strengths and cultural identity in the professional world.',
    date: '2024-12-25',
    author: 'Valentina Cruz',
    category: 'Career Development',
    image: 'https://readdy.ai/api/search-image?query=professional%20latina%20woman%20working%20on%20personal%20branding%20with%20laptop%20and%20creative%20materials%20in%20bright%20modern%20workspace&width=800&height=500&seq=blog8&orientation=landscape',
    slug: 'building-personal-brand-latina-professional',
    readTime: '5 min read'
  },
  {
    id: '9',
    title: 'The Future of Work: Preparing for Tomorrow\'s Opportunities',
    excerpt: 'Stay ahead of workplace trends and learn how to position yourself for emerging opportunities in the evolving job market.',
    date: '2024-12-22',
    author: 'Diana Flores',
    category: 'Career Development',
    image: 'https://readdy.ai/api/search-image?query=forward-thinking%20latina%20professional%20analyzing%20future%20trends%20with%20technology%20in%20modern%20innovative%20workspace&width=800&height=500&seq=blog9&orientation=landscape',
    slug: 'future-of-work-preparing-opportunities',
    readTime: '7 min read'
  }
];

const categories = ['All', 'Mentorship', 'Community', 'Success Stories', 'Career Development', 'Leadership', 'Personal Growth'];

export default function BlogPage() {
  useSEO({
    title: 'MasDeUna Blog | Latina Professional Development & Career Growth',
    description: 'Read inspiring stories, career advice, and professional development tips for Latina women. Discover mentorship insights, leadership strategies, and success stories from the MasDeUna community.',
    keywords: 'Latina professionals blog, career development, mentorship stories, leadership tips, professional growth, Latina success stories, workplace diversity, career advice',
    schema: {
      '@context': 'https://schema.org',
      '@type': 'Blog',
      name: 'MasDeUna Blog',
      description: 'Professional development and career growth resources for Latina women',
      url: 'https://www.masdeuna.org/blog',
      publisher: {
        '@type': 'Organization',
        name: 'MasDeUna',
        logo: {
          '@type': 'ImageObject',
          url: 'https://www.masdeuna.org/logo.png'
        }
      }
    }
  });

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="pt-32 pb-16 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h1 className="text-5xl font-bold text-gray-900 mb-4">
              MasDeUna Blog
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Stories, insights, and resources to empower Latina professionals on their journey to success
            </p>
          </div>

          {/* Category Filter */}
          <div className="flex flex-wrap justify-center gap-3 mb-16">
            {categories.map((category) => (
              <button
                key={category}
                className="px-6 py-2 rounded-full border-2 border-teal-500 text-teal-600 hover:bg-teal-500 hover:text-white transition-all duration-300 whitespace-nowrap cursor-pointer font-medium"
              >
                {category}
              </button>
            ))}
          </div>

          {/* Featured Post */}
          <article className="mb-20">
            <Link to={`/blog/${blogPosts[0].slug}`} className="group">
              <div className="grid md:grid-cols-2 gap-8 items-center bg-gray-50 rounded-2xl overflow-hidden hover:shadow-xl transition-shadow duration-300">
                <div className="w-full h-96 overflow-hidden">
                  <img
                    src={blogPosts[0].image}
                    alt={blogPosts[0].title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-8">
                  <div className="flex items-center gap-4 mb-4">
                    <span className="px-4 py-1 bg-teal-500 text-white text-sm font-medium rounded-full">
                      Featured
                    </span>
                    <span className="text-teal-600 font-medium">{blogPosts[0].category}</span>
                  </div>
                  <h2 className="text-3xl font-bold text-gray-900 mb-4 group-hover:text-teal-600 transition-colors">
                    {blogPosts[0].title}
                  </h2>
                  <p className="text-gray-600 mb-6 leading-relaxed">
                    {blogPosts[0].excerpt}
                  </p>
                  <div className="flex items-center gap-4 text-sm text-gray-500">
                    <span className="font-medium text-gray-700">{blogPosts[0].author}</span>
                    <span>•</span>
                    <time>{new Date(blogPosts[0].date).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</time>
                    <span>•</span>
                    <span>{blogPosts[0].readTime}</span>
                  </div>
                </div>
              </div>
            </Link>
          </article>

          {/* Blog Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {blogPosts.slice(1).map((post) => (
              <article key={post.id} className="group">
                <Link to={`/blog/${post.slug}`}>
                  <div className="bg-white rounded-xl overflow-hidden border border-gray-200 hover:shadow-xl transition-all duration-300">
                    <div className="w-full h-56 overflow-hidden">
                      <img
                        src={post.image}
                        alt={post.title}
                        className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                      />
                    </div>
                    <div className="p-6">
                      <span className="text-teal-600 text-sm font-medium">{post.category}</span>
                      <h3 className="text-xl font-bold text-gray-900 mt-2 mb-3 group-hover:text-teal-600 transition-colors">
                        {post.title}
                      </h3>
                      <p className="text-gray-600 mb-4 leading-relaxed line-clamp-3">
                        {post.excerpt}
                      </p>
                      <div className="flex items-center gap-3 text-sm text-gray-500 pt-4 border-t border-gray-100">
                        <span className="font-medium text-gray-700">{post.author}</span>
                        <span>•</span>
                        <time>{new Date(post.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}</time>
                        <span>•</span>
                        <span>{post.readTime}</span>
                      </div>
                    </div>
                  </div>
                </Link>
              </article>
            ))}
          </div>

          {/* Newsletter Subscription */}
          <section className="mt-20 bg-gradient-to-r from-teal-500 to-teal-600 rounded-2xl p-12 text-center">
            <h2 className="text-3xl font-bold text-white mb-4">
              Stay Updated with Our Latest Stories
            </h2>
            <p className="text-teal-50 mb-8 max-w-2xl mx-auto">
              Subscribe to our newsletter and get the latest insights, success stories, and career tips delivered directly to your inbox.
            </p>
            <form className="max-w-md mx-auto flex gap-3" data-readdy-form id="blog-newsletter">
              <input
                type="email"
                name="email"
                placeholder="Enter your email"
                required
                className="flex-1 px-6 py-3 rounded-lg text-gray-900 focus:outline-none focus:ring-2 focus:ring-white"
              />
              <button
                type="submit"
                className="px-8 py-3 bg-gray-900 text-white rounded-lg hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer font-medium"
              >
                Subscribe
              </button>
            </form>
          </section>
        </div>
      </section>

      <Footer />
    </div>
  );
}
